// src/components/Portfolio.js
import React from 'react';
import { TrendingUp, Clock, Shield, ArrowRight } from 'lucide-react';
import '../styles/Portfolio.css';

const Portfolio = () => {
  const caseSnapshots = [
    {
      title: "Enterprise ERP Modernization",
      client: "Manufacturing Leader",
      problem: "Legacy monolithic ERP with 6-month release cycles and frequent outages",
      approach: "Modular .NET Core microservices on Azure with CI/CD pipelines",
      outcomes: [
        { icon: <TrendingUp className="outcome-metric-icon" />, metric: "40%", label: "Faster deployment" },
        { icon: <Clock className="outcome-metric-icon" />, metric: "99.9%", label: "Uptime achieved" },
        { icon: <Shield className="outcome-metric-icon" />, metric: "Zero", label: "Security incidents" }
      ],
      technologies: ["Angular", ".NET Core", "SQL Server", "Azure", "Docker"],
      gradient: "from-blue-600 to-indigo-600"
    },
    {
      title: "Healthcare SaaS Platform",
      client: "HealthTech Startup",
      problem: "Manual deployments, no DR strategy, unclear compliance posture",
      approach: "Azure-native architecture with automated DR and HIPAA documentation",
      outcomes: [
        { icon: <Shield className="outcome-metric-icon" />, metric: "HIPAA", label: "Compliant" },
        { icon: <Clock className="outcome-metric-icon" />, metric: "< 2min", label: "Deployment time" },
        { icon: <TrendingUp className="outcome-metric-icon" />, metric: "100%", label: "Automated testing" }
      ],
      technologies: ["React", ".NET", "PostgreSQL", "Azure", "Terraform"],
      gradient: "from-green-600 to-teal-600"
    },
    {
      title: "Financial Analytics Dashboard",
      client: "FinTech Enterprise",
      problem: "Slow query performance, data inconsistencies, no real-time insights",
      approach: "SQL Server optimization, Redis caching, real-time data pipelines",
      outcomes: [
        { icon: <TrendingUp className="outcome-metric-icon" />, metric: "85%", label: "Faster queries" },
        { icon: <Clock className="outcome-metric-icon" />, metric: "Real-time", label: "Data updates" },
        { icon: <Shield className="outcome-metric-icon" />, metric: "99.99%", label: "Data accuracy" }
      ],
      technologies: ["Vue.js", ".NET Core", "SQL Server", "Redis", "Power BI"],
      gradient: "from-purple-600 to-pink-600"
    }
  ];

  return (
    <section id="portfolio" className="portfolio-section-enterprise">
      <div className="portfolio-container-enterprise">
        <div className="section-header-center">
          <span className="section-badge">Client Success Stories</span>
          <h2 className="section-title">
            Measurable Outcomes for Enterprise Clients
          </h2>
          <p className="section-description">
            Real problems solved, with quantifiable results that matter to the board.
          </p>
        </div>

        <div className="case-snapshots-grid">
          {caseSnapshots.map((caseItem, index) => (
            <div key={index} className="case-snapshot-card">
              <div className={`case-header bg-gradient-to-br ${caseItem.gradient}`}>
                <div className="case-client">{caseItem.client}</div>
                <h3 className="case-title">{caseItem.title}</h3>
              </div>

              <div className="case-content">
                <div className="case-section">
                  <h4 className="case-section-title">Problem</h4>
                  <p className="case-section-text">{caseItem.problem}</p>
                </div>

                <div className="case-section">
                  <h4 className="case-section-title">Approach</h4>
                  <p className="case-section-text">{caseItem.approach}</p>
                </div>

                <div className="case-section">
                  <h4 className="case-section-title">Outcomes</h4>
                  <div className="outcomes-metrics-grid">
                    {caseItem.outcomes.map((outcome, idx) => (
                      <div key={idx} className="outcome-metric-card">
                        {outcome.icon}
                        <div className="outcome-metric-value">{outcome.metric}</div>
                        <div className="outcome-metric-label">{outcome.label}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="case-technologies">
                  {caseItem.technologies.map((tech, idx) => (
                    <span key={idx} className="case-tech-badge">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="portfolio-cta">
          <button className="portfolio-cta-button">
            View Detailed Case Studies
            <ArrowRight className="cta-arrow" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;